/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

/**
 * EXTERNAL MODULES
 */

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import * as ActiveStorage from '@rails/activestorage';
import 'trix';
import '@rails/actiontext';

/**
 * INTERNAL MODULES
 */

// General
import '../channels';
import '../src/initializers';
import '../src/sidebar';
import '../src/application_time';
import '../src/fullscreen_button';
import '../src/dashboard';
import '../src/notifications';
import '../src/datatables';

// Settings
import '../src/roles';
import '../src/areas';
import '../src/measurement_units';
import '../src/webhook_endpoints';
import '../src/api_keys';

// Production
import '../src/products';
import '../src/product_lots';
import '../src/contacts';
import '../src/recipes';
import '../src/parameter_lists';
import '../src/scales';
import '../src/batches';
import '../src/production_orders';
import '../src/pellet_consumptions';
import '../src/stock_receipts';
import '../src/stock_issues';
import '../src/stock_adjustments';
import '../src/stock_transfers';
import '../src/micro_ingredient_orders';

// Romana
import '../src/tickets';
import '../src/ticket_items';
import '../src/load_orders';
import '../src/purchase_orders';

// Maintenance
import '../src/assets';
import '../src/scheduled_maintenance';
import '../src/maintenance_calendar';

// General Warehouse
import '../src/autorequisitions';

// Reports
import '../src/reports/production';
import '../src/reports/inventory';
import '../src/reports/romana';
import '../src/reports/maintenance';
import '../src/reports/warehouse';

ActiveStorage.start();
